import { User } from "shared/datamodel/schemas/user";
import style from "./share-user-model-cell.module.css";
import { UserRole, getUserRole } from "shared/datamodel/schemas/ability";
import { useApplyViewerRestricted } from "frontend/hooks/use-apply-viewer-restricted";

export default function ShareModalUserCell({ user }: { user: User }) {
  const applyRestrictedLimitation = useApplyViewerRestricted();
  const userRole = user && getUserRole(user, applyRestrictedLimitation);

  return (
    <div className={style.container}>
      <img src={user.thumbnail} alt={user.name} />
      <div className={style.innerContainer}>
        <div className={style.nameContainer}>
          <span className={style.name}>{user.name}</span>
          {userRole === UserRole.Restricted && <div className={style.free}>Free</div>}
        </div>
        <span className={style.email}>{user.pending ? "Invited" : user.email}</span>
      </div>
    </div>
  );
}
